import { createFileRoute } from "@tanstack/react-router";
import { ComunicacionPanel } from "@/components/admin/ComunicacionPanel";
import { paginationValidator } from "@/hooks/use-table-pagination";

export const Route = createFileRoute("/admin/comunicacion")({
  validateSearch: paginationValidator,
  component: ComunicacionPanel,
});
